<div id="app-navigation" [class.expanded]="!isSidebarCollapsed">
    @for (navList of appNavigation; track navList; let listIndex = $index) {
        <nav [id]="'app-navigation-section-' + listIndex" class="nav-list">
            @for (navItem of navList; track navItem; let navIndex = $index) {
                @if (!navItem.submenu && !navItem.isHidden && navItem.internalRoute) {
                    <a
                        (mouseenter)="navItemHover(navItem.id, $event)"
                        tooltipFocusHandler
                        [pTooltip]="isSidebarCollapsed ? (navItem.label | translate) : ''"
                        [routerLink]="navItem.url"
                        [routerLinkActive]="['active-link']"
                        [routerLinkActiveOptions]="{ exact: false }"
                        [id]="navItem.id + '-nav-link'"
                        class="nav-link">
                        <ng-container
                            [ngTemplateOutlet]="navLink"
                            [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                    </a>
                }
                @if (!navItem.submenu && !navItem.isHidden && !navItem.internalRoute) {
                    <a
                        (mouseenter)="navItemHover(navItem.id, $event)"
                        tooltipFocusHandler
                        [pTooltip]="isSidebarCollapsed ? (navItem.label | translate) : ''"
                        [href]="navItem.url"
                        [id]="navItem.id + '-nav-link'"
                        class="nav-link">
                        <ng-container
                            [ngTemplateOutlet]="navLink"
                            [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                    </a>
                }
                @if (navItem.submenu && !navItem.isHidden) {
                    <button
                        (click)="navItemClick(navItem)"
                        (mouseenter)="navItemHover(navItem.id, $event)"
                        [id]="navItem.id + '-nav-link'"
                        [class.active-link]="activeMenus[listIndex]?.[navIndex]"
                        class="nav-link">
                        <ng-container
                            [ngTemplateOutlet]="navLink"
                            [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                    </button>
                }
                <nav
                    [ngClass]="navItem.expanded ? 'submenu-expanded' : 'submenu-collapsed'"
                    class="submenu"
                    [id]="navItem.id + '-submenu'"
                    tabindex="-1">
                    @for (submenuItem of navItem.submenu; track submenuItem) {
                        @if (submenuItem.internalRoute && submenuItem.url && !submenuItem.isHidden) {
                            <a
                                [routerLink]="submenuItem.url"
                                [routerLinkActive]="['active-submenu-link']"
                                [routerLinkActiveOptions]="{ exact: false }"
                                [id]="submenuItem.id + '-submenu-nav-link'"
                                [tabindex]="!navItem.expanded ? '-1' : '0'"
                                class="submenu-link">
                                @if (!submenuItem.icon) {
                                    <div class="btn-icon-dot" [id]="submenuItem.id + '-submenu-icon'">
                                        <i class="fa-sharp fa-solid fa-circle-dot"></i>
                                    </div>
                                }
                                @if (submenuItem.icon && submenuItem.isAsset) {
                                    <div>
                                        <img
                                            [ngSrc]="submenuItem.icon"
                                            [alt]="submenuItem.label | translate"
                                            height="30"
                                            width="30" />
                                    </div>
                                }
                                @if (submenuItem.icon && !submenuItem.isAsset) {
                                    <div class="btn-icon">
                                        <i [class]="submenuItem.icon"></i>
                                    </div>
                                }
                                <span
                                    class="nav-label nav-submenu-label"
                                    [id]="submenuItem.id + '-submenu-label'"
                                    [innerHTML]="submenuItem.label | translate"></span>
                            </a>
                        }
                        @if (!submenuItem.internalRoute && submenuItem.url) {
                            <a
                                [href]="[submenuItem.url]"
                                [id]="submenuItem.id + '-submenu-nav-link'"
                                [tabindex]="!navItem.expanded ? '-1' : '0'"
                                [class.submenu-link-with-icon]="submenuItem.icon"
                                class="submenu-link">
                                @if (!submenuItem.icon) {
                                    <div class="btn-icon-dot" [id]="submenuItem.id + '-submenu-icon'">
                                        <i class="fa-sharp fa-solid fa-circle-dot"></i>
                                    </div>
                                }
                                @if (submenuItem.icon && submenuItem.isAsset) {
                                    <div>
                                        <img
                                            [ngSrc]="submenuItem.icon"
                                            [alt]="submenuItem.label | translate"
                                            height="30"
                                            width="30" />
                                    </div>
                                }
                                @if (submenuItem.icon && !submenuItem.isAsset) {
                                    <div class="btn-icon">
                                        <i [class]="submenuItem.icon"></i>
                                    </div>
                                }
                                <span class="nav-label nav-submenu-label" [id]="submenuItem.id + '-submenu-label'">{{
                                    submenuItem.label | translate
                                }}</span>
                            </a>
                        }
                        @if (!submenuItem.url && submenuItem.action) {
                            <div
                                [id]="submenuItem.id + '-submenu-nav-link'"
                                [tabindex]="!navItem.expanded ? '-1' : '0'"
                                [class.submenu-link-with-icon]="submenuItem.icon"
                                (click)="submenuItem.action()"
                                (keypress.enter)="submenuItem.action()"
                                class="submenu-link">
                                @if (!submenuItem.icon) {
                                    <div class="btn-icon-dot" [id]="submenuItem.id + '-submenu-icon'">
                                        <i class="fa-sharp fa-solid fa-circle-dot"></i>
                                    </div>
                                }
                                @if (submenuItem.icon && submenuItem.isAsset) {
                                    <div>
                                        <img
                                            [ngSrc]="submenuItem.icon"
                                            [alt]="submenuItem.label | translate"
                                            height="30"
                                            width="30" />
                                    </div>
                                }
                                @if (submenuItem.icon && !submenuItem.isAsset) {
                                    <div class="btn-icon">
                                        <i [class]="submenuItem.icon"></i>
                                    </div>
                                }
                                <span class="nav-label nav-submenu-label" [id]="submenuItem.id + '-submenu-label'">{{
                                    submenuItem.label | translate
                                }}</span>
                            </div>
                        }
                    }
                </nav>
            }
        </nav>
    }
</div>

<ng-template #navLink let-navItem="navItem">
    <div class="btn-icon" [id]="navItem.id + '-icon'">
        @if (!navItem.isAsset) {
            <i [class]="navItem.icon"></i>
        }
        @if (navItem.isAsset && navItem.id !== 'transnetyx-services') {
            <img [ngSrc]="navItem.icon" [alt]="navItem.label | translate" height="30" width="30" />
        }
        @if (navItem.id === 'transnetyx-services') {
            <div style="line-height: 10px">
                <svg
                    role="img"
                    aria-labelledby="transnetyx-services-image-svg-label"
                    width="19"
                    height="13"
                    viewBox="0 0 19 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <title id="transnetyx-services-image-svg-label">{{ navItem.label | translate }}</title>
                    <g id="Frame 3379">
                        <path
                            id="Vector"
                            d="M5.67718 6.86456V11.6366C5.67718 12.2979 5.32335 12.942 4.47124 12.942C3.61914 12.942 3.26531 12.2992 3.26531 11.6366V6.86456L0.225285 2.10973C0.0808376 1.87782 0 1.59157 0 1.30533C0 0.591041 0.482374 0 1.15823 0C1.57567 0 1.9454 0.19613 2.15478 0.536708L4.47124 4.27246L6.7877 0.536708C6.99708 0.197455 7.36682 0 7.78426 0C8.46011 0 8.94248 0.589716 8.94248 1.30533C8.94248 1.59157 8.86165 1.87782 8.7172 2.10973L5.67718 6.86456Z"
                            fill="#1C75BC" />
                        <path
                            id="Vector_2"
                            d="M17.339 12.942C16.9043 12.942 16.5823 12.7273 16.3411 12.3523L13.7026 8.27593L11.0641 12.3523C10.8229 12.7273 10.5009 12.942 10.0662 12.942C9.35858 12.942 8.84308 12.441 8.84308 11.691C8.84308 11.3159 8.98885 10.9754 9.1174 10.7792L12.3019 6.0244L9.69651 2.09252C9.53484 1.85928 9.43942 1.59159 9.43942 1.30667C9.43942 0.519499 9.9695 0.00134277 10.6613 0.00134277C11.0641 0.00134277 11.4816 0.304816 11.7068 0.662621L13.7013 3.80866L15.6957 0.662621C15.921 0.306141 16.3398 0.00134277 16.7413 0.00134277C17.4331 0.00134277 17.9645 0.519499 17.9645 1.30667C17.9645 1.59292 17.8677 1.86061 17.7061 2.09252L15.1007 6.0244L18.2852 10.7792C18.4137 10.9754 18.5595 11.3159 18.5595 11.691C18.5595 12.4424 18.0453 12.942 17.3376 12.942H17.339Z"
                            fill="#1C75BC" />
                    </g>
                </svg>
            </div>
        }
    </div>
    <span class="nav-label" [id]="navItem.id + '-label'">{{ navItem.label | translate }}</span>
    @if (navItem.submenu) {
        <div class="expand-btn-container">
            <button
                [id]="navItem.id + '-expand-submenu-btn'"
                aria-label="Toggle menu"
                tabindex="-1"
                pButton
                class="p-button-rounded p-button-text expand-menu-btn p-button-secondary">
                <i class="fa-light" [ngClass]="navItem.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
        </div>
    }
</ng-template>

<p-overlayPanel
    #ovMyOrders
    styleClass="overlay fixed-position orders-overlay"
    [style]="overlayStyle"
    [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" class="overlay">
        <div class="overlay-header">
            <p>{{ 'appNav.myOrders' | translate }}</p>
        </div>
        <div class="overlay-body">
            @for (submenu of myOrdersSubmenu; track submenu) {
                @if (!submenu.internalRoute && !submenu.isHidden) {
                    <a [href]="submenu.url" [id]="submenu.id"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'">
                            <i class="fa-sharp fa-solid fa-circle-dot"></i>
                        </div>
                        <span [innerHTML]="submenu.label | translate"></span>
                    </a>
                }
                @if (submenu.internalRoute && !submenu.isHidden) {
                    <a [routerLink]="submenu.url" [id]="submenu.id"
                        ><div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-overlay'">
                            <i class="fa-sharp fa-solid fa-circle-dot"></i>
                        </div>
                        <span [innerHTML]="submenu.label | translate"></span>
                    </a>
                }
            }
        </div>
    </div>
</p-overlayPanel>
